import {getCustomerById} from "../../../services/RequestService";

/**
 * Carrega os dados básicos do cliente. Os questionários são carregados à parte
 * (CustomerQuestionnaires → /customer_questionnaire).
 */
export default async function getCustomer(id, finishCallback) {
  if (!id) return;
  const res = await getCustomerById({userId: id});
  if (!res.ok) return;

  const a = res.data;
  const contactWay = {};
  (a.contactWay || "").split(",").filter(Boolean).forEach((item) => {
    contactWay[item] = true;
  });

  const basicData = {
    cpf: a.cpf,
    email: a.email,
    rg: a.rg,
    birthday: a.birthday,
    gender: a.gender,
    cellphone: a.phone,
    alternativePhone: a.alternativePhone,
    responsibleIdentity: a.responsibleIdentity,
    fullname: a.fullname,
    nationality: a.nationality,
    occupation: a.occupation,
    maritalStatus: a.maritualStatus,
    cep: a.addressZipCode,
    street: a.addressStreet,
    placeNumber: a.addressNumber,
    complement: a.addressComplement,
    neighborhood: a.addressDistrict,
    city: a.addressCity,
    state: a.addressState,
    registeredBy: a.registeredBy,
    indication: a.indication || "Não",
    indicatorName: a.indicatorName || "",
    indicatorDoc: a.indicatorDoc || "",
    receiveNotification: a.receiveNotification || "Não",
    education: a.education,
    contactWay,
    additionalInformation: a.additionalInformation,
  };

  finishCallback({
    customerId: a.id,
    basicData,
    isFetchingData: false,
    serverData: basicData,
  });
}
